import React, { Component } from "react";
import { Container, Col, Row } from "react-bootstrap";
import * as utils from "../../../utils.js";

export default class VistaDatosCanonicos extends Component {
  render() {
    return (
      <React.Fragment>
        <Container className="mb-3">
          <Row>
            <Col lg="4" className="border">
              <h6>Nombre</h6>
              <p>{this.props.DatosProvincia.name}</p>
            </Col>
            <Col lg="4" className="border">
              <h6>Clave</h6>
              <p>{this.props.DatosProvincia.key}</p>
            </Col>
            <Col lg="4" className="border">
              <h6>Número</h6>
              <p>{this.props.DatosProvincia.companyNumber}</p>
            </Col>
          </Row>

          <Row>
            <Col lg="6" className="border">
              <h6>Fecha de Creación</h6>
              <p>{utils.formatDate(this.props.DatosProvincia.startDate)}</p>
            </Col>
            <Col lg="6" className="border">
              <h6>Fecha de Supresión</h6>
              <p>{utils.formatDate(this.props.DatosProvincia.endDate)}</p>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}
